module.exports = __webpack_public_path__ + "static/media/search-icon.42e2c6d9.svg";